module.exports = __webpack_public_path__ + "static/media/tti_targeting.1089ed22.png";